import "../../../../assets/presentation/components/controls/button/button-label-Ccm6_fCw.css";
/* empty css             */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/button/button-label.tsx
var ButtonLabel = ({ className, children, testId }) => /* @__PURE__ */ jsx("span", {
	className: classNames(className, "label"),
	"data-testid": testId,
	children
});
//#endregion
export { ButtonLabel };

//# sourceMappingURL=button-label2.js.map